import { authApiService } from '../../authApiService';
import { ApiParams } from '../../helpers/apiHelpers';
import { ApiResponseType } from '@/types/sharedTypes';

export type CurrencyType = {
  code: string;
  number: string;
  name: string;
  is_active: boolean;
  country: string;
};

export type CurrenciesResponseType = {
  count: number;
  next: string;
  previous: string;
  results: CurrencyType[];
};

export const getCurrenciesApi = (params?: ApiParams): Promise<ApiResponseType<CurrenciesResponseType>> => {
  const uri = '/reference-books/currencies/';

  return authApiService.GET(uri, params);
};
